// extracted by mini-css-extract-plugin
export default {"pointer":"jTAO","popoverList":"vCKF"};